import React from 'react';
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

function ViewRiskCountry({ isOpen, toggle, data }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" centered>
      <ModalHeader toggle={toggle}>View Risk Information</ModalHeader>
      <ModalBody className="d-flex flex-column gap-2">
        <Col>
          <div>
            <Label>Travel Necessity</Label>
            <Input
              type="text"
              className="form-control external-filter-input"
              value={data?.[0]?.TravelNecessity ?? ''}
              disabled
            />
          </div>
        </Col>
        <Col>
          <div>
            <Label>Days Stay</Label>
            <Input
              type="text"
              className="form-control external-filter-input"
              value={data?.[0]?.DaysStay ?? ''}
              disabled
            />
          </div>
        </Col>
        <Col>
          <div>
            <Label>Location</Label>
            <Input
              type="text"
              className="form-control external-filter-input"
              value={data?.[0]?.Locations ?? ''}
              disabled
            />
          </div>
        </Col>
        <Col>
          <div>
            <Label>Precautions</Label>
            <Input
              type="text"
              className="form-control external-filter-input"
              value={data?.[0]?.Precautions ?? ''}
              disabled
            />
          </div>
        </Col>
        <Col>
          <div>
            <Label>Customer Contact</Label>
            <Input
              type="text"
              className="form-control external-filter-input"
              value={data?.[0]?.CustomerContact ?? ''}
              disabled
            />
          </div>
        </Col>
      </ModalBody>
      <ModalFooter>
        <button type="button" onClick={toggle} className="custom-btn">
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ViewRiskCountry;
